/* Keeps --olj-hh equal to the real height of the sticky site header, so Journal
   jump bars and sticky headings sit directly underneath it. See ol-journal-sticky.css.

   Auto fix (3 Nov 2026): articles hard-code sticky "top" values against the tall
   header (e.g. top:184px), so once the header shrinks the page shows through a gap.
   The CSS file only knows the class names of older articles. This finds any other
   sticky bar or heading in the page and pins it under the live header, so every new
   article is covered without editing the theme:
   - the jump bar (widest sticky element nearest the top) sits flush under the header
   - sticky headings inside the jump bar's section sit under the bar, keeping the
     article's own gap; others sit 25px under the header
   Elements the CSS file already handles are left alone (tested live, not by name). */
(function () {
  var header = document.querySelector('.sticky-header') || document.querySelector('.shopify-section-header');
  if (!header) return;
  var root = document.documentElement;
  var HEADER_SEL = '.sticky-header, .shopify-section-header, header';
  var AUTO = 'data-olj-auto';

  function update() {
    var h = Math.round(header.getBoundingClientRect().height);
    if (h > 0) root.style.setProperty('--olj-hh', h + 'px');
  }

  function scrollsInside(el) {
    for (var p = el.parentElement; p && p !== document.body && p !== root; p = p.parentElement) {
      var o = getComputedStyle(p);
      if (/(auto|scroll|hidden)/.test(o.overflowY + o.overflowX)) return true; /* clip keeps sticky working */
    }
    return false;
  }

  function isBar(el) {
    return el.tagName === 'NAV' || /jump|toc|contents/i.test(el.className || '') ||
      el.getBoundingClientRect().width >= window.innerWidth * 0.6;
  }

  function autoFix() {
    var done = document.querySelectorAll('[' + AUTO + ']');
    for (var i = 0; i < done.length; i++) {
      done[i].style.removeProperty('top');
      done[i].removeAttribute(AUTO);
    }

    var scope = document.querySelector('main') || document.body;
    var all = scope.getElementsByTagName('*');
    var found = [];
    for (var j = 0; j < all.length; j++) {
      var el = all[j];
      var cs = getComputedStyle(el);
      if (cs.position !== 'sticky' || cs.display === 'none') continue;
      if (el.closest(HEADER_SEL)) continue;
      var top = parseFloat(cs.top);
      if (!(top >= 60)) continue; /* only tops written to clear the site header */
      if (scrollsInside(el)) continue; /* sticky inside its own scroll box */
      found.push({ el: el, top: top });
    }
    if (!found.length) return;

    /* leave elements the CSS file already ties to --olj-hh */
    var hh = parseFloat(getComputedStyle(root).getPropertyValue('--olj-hh')) || 121;
    root.style.setProperty('--olj-hh', (hh + 7) + 'px');
    found = found.filter(function (f) { return Math.abs(parseFloat(getComputedStyle(f.el).top) - f.top) < 1; });
    root.style.setProperty('--olj-hh', hh + 'px');
    update();
    if (!found.length) return;

    found.sort(function (a, b) { return a.top - b.top; });
    var bar = null;
    for (var k = 0; k < found.length; k++) { if (isBar(found[k].el)) { bar = found[k]; break; } }
    var barH = bar ? Math.round(bar.el.getBoundingClientRect().height) : 0;

    found.forEach(function (f) {
      var value;
      if (f === bar) {
        value = 'calc(var(--olj-hh, 121px) - 1px)';
      } else if (bar && barH && bar.el.parentElement.contains(f.el)) {
        var gap = Math.min(40, Math.max(8, Math.round(f.top - bar.top - barH)));
        value = 'calc(var(--olj-hh, 121px) + ' + (barH - 1 + gap) + 'px)';
      } else {
        value = 'calc(var(--olj-hh, 121px) + 25px)';
      }
      f.el.style.setProperty('top', value, 'important');
      f.el.setAttribute(AUTO, '');
    });
  }

  update();
  if (window.ResizeObserver) new ResizeObserver(update).observe(header);
  window.addEventListener('resize', update, { passive: true });

  var timer;
  function run() { clearTimeout(timer); timer = setTimeout(function () { update(); autoFix(); }, 120); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  window.addEventListener('load', run);
  var lastW = window.innerWidth;
  window.addEventListener('resize', function () { if (window.innerWidth !== lastW) { lastW = window.innerWidth; run(); } }, { passive: true });
})();
